import { keepGuestForShare } from "./guest-share";
import { useAuth } from "./useAuth";

/**
 * Stash the guest token when Share opens sign-in.
 * An owner click has a members href, so nothing is stored.
 */
export function onGuestShareClick(shareHref: string | undefined): void {
  const state = useAuth.getState();
  if (!state?.token || !state.guest || state.user) return;
  keepGuestForShare(state.token, shareHref);
}
